import { ROUTES } from "@/constants/routes";
import { RailHeadingLink } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/rail/RailHeadingLink";
import { Archive } from "lucide-react";
import { useMatch, useNavigate } from "react-router-dom";

/** Rail link to the Archived page — "deleting" anything archives it there. */
export function WorkspaceRailTrashLink() {
  const navigate = useNavigate();
  const isArchive = useMatch(ROUTES.ARCHIVE.ROOT);

  return (
    <RailHeadingLink
      icon={Archive}
      label="Archived"
      active={!!isArchive}
      onClick={() => navigate(ROUTES.ARCHIVE.ROOT)}
    />
  );
}
